import ApiService from "./ApiService";

const DashboardService = {
    countModel() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/count').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    sumInferences() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/inference/count').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    countTrainHistory() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/train-history/count').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getModelTrainHistoryAccuracy() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/train-history/accuracy').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getBestAccuracy() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/train-history/accuracy-count').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getModelCountInferences() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/inference/count').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    }
};

export default DashboardService
